export default __webpack_public_path__ + "static/media/imp_water.848901c6.mp4";